








































import {Component, Mixins} from 'vue-property-decorator';
import {
    AdminRolesListInfo, AdminRolesRetrieveResponse,
    CommonModelUtils,
    MultipleRolesSelectDialogRequest,
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import IconButton from '@/components/button/IconButton.vue';
import AdminApi from '@/api/AdminApi';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';

@Component({
    components: {IconButton, TextInput, CommonPromptDialog, CommonPaginatedTable, CommonButton},
  mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin]
})
export default class MultipleRolesSelectDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin) {
    private selectedRoles: AdminRolesListInfo[] = [];
    private selectedRoleKeyMap: any = {};
    private onSelect: ($event: any, roles: AdminRolesListInfo[]) => void;
    private values: AdminRolesListInfo[] = [];

    get getValues() {
        return this.values;
    }

    get roleColumns() {
       return [
            {
                columnId: 'ROLE_NAME',
                columnLabel: this.$root.$t('message.admin.role.role').toString(),
                filtered: 'N',
                visible: 'Y'
            }
        ];
    }
    get getRowClassSupplier() {
        return (row: AdminRolesListInfo) => {
            return {'selected': this.selectedRoleKeyMap[row.ROLE_ID]};
        };
    }

    public getLabel(role: AdminRolesListInfo) {
        return role.ROLE_NAME
            ? `${role.ROLE_NAME.length > 40 ? `${role.ROLE_NAME.substr(0, 40)}...` : role.ROLE_NAME}`
            : '';
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('multipleRolesSelectDialog', (params: MultipleRolesSelectDialogRequest) => {
                this.width = params.width ? params.width : this.DEFAULT_WIDTH;
                this.selectedRoles = [...params.selectedRoles];
                this.selectedRoleKeyMap = this.selectedRoles.reduce((map: any, role: AdminRolesListInfo) => {
                    map[role.ROLE_ID] = role.ROLE_ID;
                    return map;
                }, {});
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideMultipleRolesSelectDialog', () => this.onCancel());
    }

    public show(request: MultipleRolesSelectDialogRequest) {
        this.visible = true;
        this.onSelect = request.onSelect;
        this.retrieve(1, 10);
    }

    public onCloseTag($event: MouseEvent, target: AdminRolesListInfo) {
        const targetIndex = this.selectedRoles.findIndex((role: AdminRolesListInfo) => role.ROLE_ID === target.ROLE_ID);
        this.unSelect(targetIndex);
    }

    public onRowClick(data: any) {
        const {row, $event} = data;
        const targetIndex = this.selectedRoles.findIndex((role: AdminRolesListInfo) => role.ROLE_ID === row.ROLE_ID);
        if (targetIndex >= 0) {
            this.unSelect(targetIndex);
        } else {
            this.selectedRoles.push(row);
            this.selectedRoleKeyMap = {
                ...this.selectedRoleKeyMap,
                [row.ROLE_ID]: row.ROLE_ID
            };
        }
    }

    private unSelect(targetIndex: number) {
        if (targetIndex >= 0) {
            const unSelected: AdminRolesListInfo = this.selectedRoles.splice(targetIndex, 1)[0];
            this.selectedRoleKeyMap[unSelected.ROLE_ID] = false;
        }
    }

    public retrieve(pageNo: number, rowCount: number) {
        this.loading = true;
        return AdminApi.retrieveAdminRoles(this.$route.params.sponsorKey)
            .then((res: AdminRolesRetrieveResponse) => {
              if (!res.success) {
                return Promise.reject(res.errMsg);
              }

              const paginate = CommonModelUtils.getOrDefaultPaginate(res.data);
              this.values = paginate.listInfo.filter((it: any) => it.DEL_FLAG === 'N');
              this.pageInfo = {
                menuId: '',
                pageNo: 1,
                rowCount: 100,
                totalCount: this.values.length,
                totalPage: 1
              };
            })
            .catch((errMsg) => this.afterRequestFail(errMsg))
            .finally(() => this.loading = false);
    }

    public onConfirm($event: any) {
        this.onSelect($event, this.selectedRoles);
        this.visible = false;
    }

    public onCancel() {
        this.visible = false;
    }

    public afterClosed() {
        this.values = [];
        this.selectedRoles = [];
        this.selectedRoleKeyMap = {};
        this.keyword = '';
        this.loading = false;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('multipleRolesSelectDialog');
        this.$modal.getEventBus().$off('hideMultipleRoleSelectDialog');
    }
}
